export default __webpack_public_path__ + "static/media/Data_analytics_preview.371526fb.png";